import UserOperatorListParams from "./user-operator-list-params";
import UserOperatorList from "./user-operator-list";
import UserOperatorListError from "./user-operator-list-error";
import useAsyncData from "../../../../hooks/use-async-data";
import userService from "../../user.service";

const useOperatorList = () => {
  const { isLoading, setIsLoading, isError, setIsError, data, setData } =
    useAsyncData<UserOperatorList>({ data: [], totalCount: 0 });

  const load = async (
    params: UserOperatorListParams,
    signal: AbortSignal,
  ): Promise<void> => {
    setIsLoading(true);
    setIsError(false);

    try {
      const operatorList = await userService.getOperatorList(params, signal);

      setData(operatorList);
    } catch (_error) {
      const error = _error as UserOperatorListError;

      setIsError(true);
    } finally {
      setIsLoading(false);
    }
  };

  return {
    isLoading,
    isError,
    data,
    load,
  };
};

export default useOperatorList;
